/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'mark-as-delivered': {
    width: 11,
    height: 9,
    viewBox: '0 0 11 9',
    data: '<path pid="0" d="M1.22 4.975l-.845.922 2.677 2.452a.625.625 0 0 0 .886-.041l6.261-6.922-.927-.838-5.84 6.455L1.22 4.975z" _fill="#376F99" fill-rule="nonzero"/>'
  }
})
